import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OrganizationEloSettingsDto, UpdateOrganizationEloSettingsDto } from '../../../models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { GET_ELO_SETTINGS_QUERY_KEY } from './useGetEloSettings';

export const useUpdateEloSettings = (organizationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateEloSettings', organizationId],
        mutationFn: (body: UpdateOrganizationEloSettingsDto) =>
            apiClient.fetchApi<OrganizationEloSettingsDto, UpdateOrganizationEloSettingsDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/elo-settings`,
                body,
            }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_ELO_SETTINGS_QUERY_KEY(organizationId), data);
            onSuccess();
        },
    });
};
